import { useState } from 'react';
import { useTrip } from '../../contexts/trip-context';
import { createTripItinerary } from '../../../services/trips/trip-itinerary.service';

export interface IAddItineraryModel {
  title: string;
  description?: string;
}

export const useAddItinerary = (onSuccess?: () => void) => {
  const [itinerary, setItinerary] = useState<IAddItineraryModel>({
    title: '',
    description: ''
  });

  const [validated, setValidated] = useState(false);
  const { trip, setRefreshTrip } = useTrip();

  const handleInputChange = (field: keyof IAddItineraryModel, value: any) => {
    setItinerary((prev) => {
      const updated = {
        ...prev,
        [field]: value
      };

      // Validate - require title
      setValidated(updated.title.trim().length > 0);

      return updated;
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!trip?.id) {
      alert('No trip selected');
      return;
    }

    if (!itinerary.title.trim()) {
      alert('Itinerary title is required');
      return;
    }

    try {
      console.log('Creating itinerary:', itinerary);
      const result = await createTripItinerary(trip.id, {
        title: itinerary.title,
        description: itinerary.description,
        tripId: trip.id
      });

      if (result) {
        console.log('Itinerary created successfully:', result);
        setRefreshTrip(true); // Trigger a refresh of trip data
        setItinerary({
          title: '',
          description: ''
        });
        onSuccess?.();
      } else {
        alert('Failed to create itinerary');
      }
    } catch (error) {
      console.error('Error creating itinerary:', error);
      alert('An error occurred while creating the itinerary');
    }
  };

  return {
    itinerary,
    validated,
    handleInputChange,
    handleSubmit
  };
};
